import FunnelHeader from "@components/quiz/FunnelHeader"
import FunnelLayout from "@components/quiz/FunnelLayout"
import Spinner from "@components/Spinner"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { ReactTyped } from "react-typed"

export default function PreparingPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/checkout/plans")
    }, 7000)

    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <FunnelLayout header={<FunnelHeader />}>
      <div className="flex grow flex-col gap-6 pb-16 pt-4">
        <h1 className="vm-heading animate-fade-up">
          {t("pages.signUp.loading.heading")}
        </h1>

        <div className="flex grow items-center justify-center">
          <div className="vm-card flex w-full animate-scale-in flex-col items-center gap-5 p-8 text-center">
            <Spinner />

            <p
              aria-live="polite"
              className="min-h-7 text-lg font-semibold text-vm-ink"
            >
              <ReactTyped
                fadeOut
                fadeOutDelay={500}
                strings={[
                  t("pages.signUp.loading.analyzingResponses"),
                  t("pages.signUp.loading.preparingInterface"),
                  t("pages.signUp.loading.creatingMindMapTopics"),
                ]}
                typeSpeed={40}
              />
            </p>
          </div>
        </div>
      </div>
    </FunnelLayout>
  )
}
